import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AllTransactions from './components/AllTransactions/AllTransactions';
import Balance from './components/Balance';
import Form from './components/Form';
import Layout from './components/Layout';
import Transactions from './components/Transactions/Transactions';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Balance />
              <Form />
              <Transactions />
            </Layout>
          }
        />
        <Route path="allTransactions" element={<AllTransactions />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
